import axios from 'axios';
import { notifyTimesheetWorkHoursPersisted } from './utils/timesheetSalarySync';

// const API_BASE_URL = 'http://localhost:5500/api';
const API_BASE_URL = '/api'
// const API_BASE_URL = 'https://tablescraping.duckdns.org/api';
//const API_BASE_URL = 'http://159.89.83.80/api';
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Centralized salary-sync interceptor.
 * Fires notifyTimesheetWorkHoursPersisted for any successful mutation that touches
 * timesheet or salary-report data, so that OTHER tabs / consumers can refetch.
 *
 * Covered routes:
 *   PUT   /timesheet/:id                                              — work-hour auto-save
 *   POST  /timesheet/manual                                           — manual timesheet creation
 *   POST  /timesheet/ai-edit/:id                                      — AI-based work-hour edits
 *   PATCH /month-records/:id/salary-report/timesheets/:tid/day/:d     — salary single-day edit
 *   PATCH /month-records/:id/salary-report/bulk-update                — salary bulk save
 *   POST  /month-records/:id/salary-report/employees/:eid/day/:d/manual — salary manual entry
 *   POST  /month-records/:id/salary-report/employees/:eid/bulk-assignment — salary bulk assignment
 *   PATCH /month-records/:id/salary-report/employees/:eid/day/:d/assignment — salary assignment
 */
axiosInstance.interceptors.response.use(
    (response) => {
        const cfg = response?.config;
        if (!cfg) return response;

        const method = String(cfg.method || '').toLowerCase();
        const rawUrl = String(cfg.url || '').split('?')[0];
        const base = String(cfg.baseURL || '');
        const path = base && rawUrl.startsWith(base) ? rawUrl.slice(base.length) : rawUrl;

        const body = response?.data;
        if (!body?.success) return response;

        let timesheetId = null;
        let month = NaN;
        let year = NaN;

        if (method === 'put' && /^\/timesheet\/[^/]+$/.test(path)) {
            const ts = body.timesheet;
            timesheetId = path.replace(/^\/timesheet\//, '');
            month = Number(ts?.month);
            year = Number(ts?.year);
        } else if (method === 'post' && (path === '/timesheet/manual' || path === 'timesheet/manual')) {
            const file = body.file;
            timesheetId = String(file?.id || file?._id || '');
            month = Number(file?.month);
            year = Number(file?.year);
        } else if (method === 'post' && /^\/timesheet\/process\/[^/]+$/.test(path)) {
            // An AI (re-)analysis REPLACES the card's hours on the server. A
            // FileModal open on that card in another tab still holds the old
            // grid — empty, for a "ללא שעות" card the intake ledger re-read —
            // and its next autosave would PUT that grid back over the AI's
            // hours. Broadcasting makes it re-fetch, like every other writer.
            timesheetId = path.replace(/^\/timesheet\/process\//, '');
            month = Number(body.result?.month);
            year = Number(body.result?.year);
        } else if (method === 'post' && /^\/timesheet\/ai-edit\/[^/]+$/.test(path)) {
            timesheetId = path.replace(/^\/timesheet\/ai-edit\//, '');
            const ts = body.timesheet || body;
            month = Number(ts?.month);
            year = Number(ts?.year);
        } else if (
            /^\/month-records\/[^/]+\/salary-report\//.test(path)
            && (method === 'patch' || method === 'post')
        ) {
            // Salary-report mutations (single-day edit, bulk-update, manual entry, assignments).
            // We may not know the exact timesheetId; use a sentinel so the notification fires.
            timesheetId = '__salary_report__';
        }

        if (timesheetId) {
            notifyTimesheetWorkHoursPersisted({ timesheetId, month, year });
        }

        return response;
    },
    (err) => Promise.reject(err)
);

export default axiosInstance;
